import { Link, useSearchParams } from 'react-router-dom';
import { GITHUB_APP_INSTALL_URL } from '@/lib/config';

const REASON_MESSAGES: Record<string, string> = {
  missing_installation_id:
    "GitHub didn't send an installation id back — that usually means the install didn't complete. Try installing the App again.",
  provisioning_failed:
    "We received the install but couldn't reach GitHub to finish setting up your organization. Please try again in a moment.",
  request_pending:
    "Your install request was sent to the organization owner. You'll get access once they approve it.",
  request:
    "Your install request was sent to the organization owner. You'll get access once they approve it.",
};

export default function OnboardingErrorPage() {
  const [params] = useSearchParams();
  const reason = params.get('reason') ?? '';
  const message = REASON_MESSAGES[reason] ?? `Onboarding failed (${reason || 'unknown reason'}).`;

  return (
    <div className="centered-full">
      <div className="card" style={{ maxWidth: 520 }}>
        <h2>Onboarding didn't finish</h2>
        <p>{message}</p>
        <div className="form-actions">
          <a className="btn btn-primary" href={GITHUB_APP_INSTALL_URL} target="_blank" rel="noreferrer">
            Install the GitHub App
          </a>
          <Link to="/dashboard" className="btn btn-ghost">
            Back to dashboard
          </Link>
        </div>
      </div>
    </div>
  );
}
